<template>
  <section class="w product-detail--wraper">
    <slot></slot>
  </section>
</template>
<script>
export default {
  name: 'Wrapper'
}
</script>
<style lang="scss" scoped>
.product-detail--wraper {
  background-color: #fff;
  padding: 0 0.3rem;
  margin: 0.2rem 0 0;
}
</style>
